module.exports = __webpack_public_path__ + "static/fonts/proximasoftlight-webfont.87a670c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximasoftlight-webfont.woff
// module id = 1023
// module chunks = 11